

















































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { date } from 'quasar'
import store from 'src/assets/store'
import { StudentGradebook } from 'src/assets/AttendeeItemData'
import PersonAvatar from 'components/account/PersonAvatar.vue'
import { Item, Student, StudentGroup, SessionAttendee } from 'src/graphql/types'

@Component({
  components: {
    PersonAvatar
  }
})
export default class ItemCourseGradebookStudentsListItem extends Vue {
  formatDate = date.formatDate
  results: Json = {
    total: 0
  }

  @Prop()
  readonly topics!: Map<number, Item>

  @Prop()
  readonly student!: Student

  @Prop()
  readonly group!: StudentGroup

  get item () {
    return store.state.presenter.item
  }

  load () {
    const gradebook = new StudentGradebook(this.topics, this.student.sessionAttendees.nodes as SessionAttendee[])
    this.results = gradebook.results
  }
}
